exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer[data-v-1ff863eb]{background:#fff;padding:1rem 0 .8rem;color:#f26722;line-height:1.4em}.logo[data-v-1ff863eb]{display:block;margin:0 auto 1rem}@media (min-width:576px){.logo[data-v-1ff863eb]{float:left;margin-right:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ff863eb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 34
// module chunks = 0